import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-32" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-33" data-mp="1mb3xextzeule">
        <h2 className="text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-34" data-mp="1r3ncy0c8bzsu">
          This isn't just another histology &amp; pathology ebook
        </h2>
        <p className="mt-0.5 font-heading text-xs font-extrabold uppercase tracking-wide text-magenta sm:text-sm" data-id="element-35" data-mp="zd0ncfjtxo7k">
          It's a ready-to-use visual study system.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-36" data-mp="13g5pggzzznvo">
          {differentiators.map(item => <div key={item.title} className="rounded-md border border-electric/40 bg-electric/5 px-2.5 py-2" data-id="element-37" data-mp="1dcif93sf9hl5">
              <h3 className="text-sm font-extrabold text-navy" data-id="element-38" data-mp="2jt3z4g99akgm">
                <span aria-hidden="true" data-id="element-39" data-mp="2juota4rns1dy">{item.icon}</span> {item.title}
              </h3>
              <p className="mt-0.5 text-sm leading-snug" data-id="element-40" data-mp="2opugr80plo45">{item.body}</p>
            </div>)}
        </div>
        <p className="mt-2 font-heading text-xs font-extrabold uppercase tracking-wide text-navy sm:text-sm" data-id="element-41" data-mp="bmhqln226qsa">
          Less searching. Less confusion. More visual clarity.
        </p>
      </div>
    </section>;
}